import { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import Providers from "ui/Providers";
import Router from "ui/router/Router";
import { initAxiosTokenGetter } from "features/shared/api/initAxiosForMigration";

initAxiosTokenGetter();
import "ui/locale/i18n";
import "common/utils/Polyfill";
import * as serviceWorker from "./serviceWorker";
import LoadingPage from "./ui/common/pages/LoadingPage/LoadingPage";

const App = (): JSX.Element | null => {
    return (
        <Suspense fallback={<LoadingPage />}>
            <Providers>
                <Router />
            </Providers>
        </Suspense>
    );
};

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
    // <StrictMode>
        <App />
    // </StrictMode>,
);

serviceWorker.register();
